<template>
  <div
    class="item"
    :class="styleRead"
    @click="showMessage()"
    >

    <div class="cell-left">
      {{ content }}
    </div>

    <div class="cell-right">
      {{ messageDate(message) }}
    </div>
  </div>
</template>

<script>
import MixinLocale from '@/components/MixinLocale'

export default {
  props: {
    message: {
      required: true,
      type: Object
    },

    statusRead: {
      required: true,
      type: Boolean
    }
  },

  data () {
    return {
      read: false
    }
  },

  created: function () {
    this.read = this.statusRead
  },

  mixins: [
    MixinLocale
  ],

  computed: {
    content: function () {
      return this.message.get('content')
    },

    styleRead: function () {
      if (this.read) {
        return {}
      }
      return { unread: true }
    }
  },

  methods: {
    messageDate: function (message) {
      return this.$store.getters['message/date'](message)
    },

    showMessage: function () {
      this.read = true
      this.$store.commit('message/setMessage', this.message)
      this.$store.dispatch('popup/show', 'messageShow')
    }
  }
}
</script>

<style lang="scss" scoped>
.unread {
  font-weight: bold;
}
</style>
